import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerPersona,
  BackendMutationUpdateCustomerPersonaArgs,
} from 'src/types/backend';

import { CUSTOMER_PERSONA_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation UpdateCustomerPersona(
    $id: ID!
    $name: String!
    $minAge: Int!
    $maxAge: Int!
    $gender: GenderEnum!
    $painPoints: [String!]!
    $avatarType: String
    $projectId: ID
    $approve: Boolean
    $brandVoiceId: ID
  ) {
    updateCustomerPersona(
      id: $id
      name: $name
      minAge: $minAge
      maxAge: $maxAge
      gender: $gender
      painPoints: $painPoints
      avatarType: $avatarType
      projectId: $projectId
      approve: $approve
      brandVoiceId: $brandVoiceId
    ) {
      ...CustomerPersona
    }
  }
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

type Variables = BackendMutationUpdateCustomerPersonaArgs;
type Result = BackendCustomerPersona;

export const updateCustomerPersona = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
